<div class="custom-accordion mt-5" id="series_1_1">
    <div class="accordion-item">
        <div class="row">
            <div class="col-md-3 col-sm-3 col-lg-3 align-self-center">
                <img class="w-100" src="assets/images/marketing/email-template.png" alt="anxiety">
            </div>
            <div class="col-md-7 col-sm-7 col-lg-7 align-self-center">
                <h3 class="row-title">Email from CEO</h3>
                <p>Explaining that your organisation is on board, and part of the mission to help kiwis.</p>
            </div>
            <div class="col-md-2 col-sm-2 col-lg-2 align-self-center text-right pr-0">
                <button class="btn btn-link collapsed bg-transparent" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne"></button>
            </div>
        </div>

        <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#series_1_1">
            <div class="accordion-body">
                <p>Send the following as an email:</p>
                <p class="mb-0"><strong>Subject:</strong></p>
                <p>Anxious?</p>
                <p class="mb-0"><strong>EDM:<br></strong></p>
                <p>Morena everyone,</p>
                <p class="mt-4">Anxiety is fast becoming one of New Zealand’s biggest mental health concerns. We all suffer from it to some degree, and children as young as 6 years old have reported experiencing anxiety..
                </p>
                <p class="mt-4">At The Warehouse, we’ve made it our mission to be genuinely helpful to all New Zealanders. We saw an opportunity to partner with Take a Breath to teach you - our valued staff, to learn better breathing habits, scientifically proven to
                    alleviate symptoms of stress and anxiety.</p>
                <p class="mt-4">This mission is all about getting as many Kiwis as possible thinking about how they’re breathing, finding out how they can improve, and to help them kick start the habit of practicing healthier breathing.</p>
                <p class="mt-4">We’d love it if you would all sign up for the opportunity. And when you do, you have the chance to offer the programme to your friends and family as well.</p>
                <p class="mt-4">It doesn’t take much to get involved, but it could potentially have a massive effect on reducing anxiety throughout the country if we all get behind it 100%.</p>
                <p class="mt-4">So let’s do it. Watch out for more information in the coming days.</p>
                <p class="mt-4">Hau pai, breathe well</p>
            </div>
        </div>
    </div>
</div>

<div class="custom-accordion mt-3" id="series_1_2">
    <div class="accordion-item">
        <div class="row">
            <div class="col-md-3 col-sm-3 col-lg-3 align-self-center">
                <img class="w-100" src="assets/images/marketing/email-hr.png" alt="anxiety">
            </div>
            <div class="col-md-7 col-sm-7 col-lg-7 align-self-center">
                <h3 class="row-title">Email from HR</h3>
                <p>Includes more information and an invitation to attend seminars</p>
            </div>
            <div class="col-md-2 col-sm-2 col-lg-2 align-self-center text-right pr-0">
                <button class="btn btn-link collapsed bg-transparent" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo"></button>
            </div>
        </div>

        <div id="collapseTwo" class="collapse" aria-labelledby="headingOne" data-parent="#series_1_2">
            <div class="accordion-body">
                <p>Send the following as an email:</p>
                <p class="mb-0"><strong>Subject:</strong></p>
                <p>Curious?</p>
                <p class="mb-0"><strong>EDM:<br></strong></p>
                <p>Morena everyone,</p>
                <p class="mt-4 mb-0">We have an exciting new programme for you.</p>
                <p class="mb-0">The Take a Breath programme is the world’s first digital platform that teaches the direct link between how we breathe and health.</p>
                <p class="mb-0">We want as many of you as possible to sign up.</p>
                <p class="mb-0 mt-4">Over the coming months there will be seminars to attend, you’ll have access to the simple, step-by-step programme, and we’ve designed some interesting initiatives to help you practice good breathing, uninterrupted, while you work.</p>

                <p class="mt-4">We want to help all New Zealanders, so once you’ve signed up, you can also nominate friends or family to have free access as well.</p>
                <p class="mt-4">This can be a game-changer for health.</p>
                <p class="mt-4 mb-0">Take a Breath kicks off with a series of seminars for all of us, and we’d love you to register.</p>
                <p class="mb-0">Dates are attached.</p>
                <p>Please use the link to register.</p>
                <p class="mt-4">Hau pai, breathe well</p>
            </div>
        </div>
    </div>
</div>

<div class="custom-accordion mt-3" id="series_1_3">
    <div class="accordion-item">
        <div class="row">
            <div class="col-md-3 col-sm-3 col-lg-3 align-self-center">
                <img class="w-100" src="assets/images/marketing/social-post.png" alt="anxiety">
            </div>
            <div class="col-md-7 col-sm-7 col-lg-7 align-self-center">
                <h3 class="row-title">Social Post</h3>
                <p>Use the following on your social post:</p>
            </div>
            <div class="col-md-2 col-sm-2 col-lg-2 align-self-center text-right pr-0">
                <button class="btn btn-link collapsed bg-transparent" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree"></button>
            </div>
        </div>

        <div id="collapseThree" class="collapse" aria-labelledby="headingOne" data-parent="#series_1_3">
            <div class="accordion-body">
                <p>These seminars will be awesome.</p>
                <p class="mt-4">REGISTER HERE: <a target="_blank" href="https://www.takeabreath.world/community-seminar-register/">https://www.takeabreath.world/community-seminar-register/</a></p>
                <p class="mt-4">Feedback from other people and companies is that ‘everyone needs to know this stuff’.Learn the science, learn why you think and feel the way you do when you’re stressed. Learn how to prevent it.</p>
                <p>
                    <img src="assets/images/marketing/series_1_3.png" alt="anxiety">
                </p>
                <p><strong>Social Image</strong></p>
                <a download="anxiety.png" href="assets/images/marketing/download_1_3.png"><i class="fa fa-cloud-download"></i> Download here</a>
            </div>
        </div>
    </div>
</div>